import { PivotPanel, PivotGrid, PivotChart } from "@grapecity/wijmo.react.olap";
import { Control, format } from "@grapecity/wijmo";
import {
  Grid,
  IconButton,
  Stack,
  Box,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import FolderStructure from "../FolderStructure";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import {
  IconAccessible,
  IconChartBar,
  IconFolder,
  IconGridPattern,
  IconSettings,
} from "@tabler/icons-react";
import excel from "src/assets/images/excelIcon.png";
import { FlexGridXlsxConverter } from "@grapecity/wijmo.grid.xlsx";
import { format as dateFormat } from "date-fns";
import { Can } from "context/permissionContenxt";

const PivotComponents = (props) => {
  const {
    ngPanel,
    columns,
    title,
    handleNavigate,
    explorerDataKey,
    hideStatistics,
    treeItems,
  } = props;

  const pivotGridRef = useRef();

  const handleDoubleClick = (e, detailGrid) => {
    const ht = detailGrid.hitTest(e.pageX, e.pageY);
    const currentItem = ht?.grid?.collectionView.currentItem;
    handleNavigate(currentItem, true);
  };

  const [hideFolder, setHideFolder] = useState(false);
  const [hidePanel, setHidePanel] = useState(true);
  const [hideGrid, setHideGrid] = useState(false);
  const [hideChart, setHideChart] = useState(false);

  const handleHideFolder = () => setHideFolder(!hideFolder);
  const handleHidePanel = () => setHidePanel(!hidePanel);
  const handleHideGrid = () => {
    if (!hideGrid && hideChart) {
      setHideChart(false);
    }
    setHideGrid(!hideGrid);
  };
  const handleHideChart = () => {
    if (!hideChart && hideGrid) setHideGrid(false);
    setHideChart(!hideChart);
  };

  const handleDefaultExport = () => {
    FlexGridXlsxConverter.saveAsync(
      pivotGridRef?.current,
      {
        includeColumnHeaders: true,
        includeRowHeaders: true,
        includeStyles: false,
      },
      `${dateFormat(new Date(), "yyyy_MM_dd_HHmm")}`
    );
  };

  return (
    <>
      <Can I="View" a="GovnrApplications" passThrough>
        {(allowed) => (
          <>
            <Grid item xs={12}>
              <Stack
                direction="row"
                gap={1}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Typography variant="h3">{title}</Typography>
                <Box
                  boxShadow={2}
                  sx={{
                    borderRadius: 40,
                    backgroundColor: hideFolder ? "" : "#ffd35e",
                  }}
                >
                  <Tooltip
                    title={`${
                      hideFolder ? "Εμφάνιση" : "Απόκρυψη"
                    } Στατιστικών`}
                  >
                    <IconButton onClick={handleHideFolder}>
                      <IconFolder />
                    </IconButton>
                  </Tooltip>
                </Box>
                {/* {allowed && (
                  <Box
                    boxShadow={2}
                    sx={{
                      borderRadius: 40,
                      backgroundColor: hidePanel ? "" : "#ffd35e",
                    }}
                  >
                    <Tooltip title="Επιλογή πεδίων">
                      <IconButton onClick={handleHidePanel}>
                        <IconSettings />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )} */}
                <Box
                  boxShadow={2}
                  sx={{
                    borderRadius: 40,
                    backgroundColor: hideGrid ? "" : "#ffd35e",
                  }}
                >
                  <Tooltip
                    title={`${hideGrid ? "Εμφάνιση" : "Απόκρυψη"} Πίνακα`}
                  >
                    <IconButton onClick={handleHideGrid}>
                      <IconGridPattern />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  boxShadow={2}
                  sx={{
                    borderRadius: 40,
                    backgroundColor: hideChart ? "" : "#ffd35e",
                  }}
                >
                  <Tooltip
                    title={`${hideChart ? "Εμφάνιση" : "Απόκρυψη"} "Πίτας"`}
                  >
                    <IconButton onClick={handleHideChart}>
                      <IconChartBar />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box boxShadow={2} sx={{ borderRadius: 40 }}>
                  <Tooltip title="Εξαγωγή σε Excel">
                    <IconButton onClick={handleDefaultExport}>
                      <img
                        alt="excel_export"
                        src={excel}
                        style={{ height: "24px  " }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box boxShadow={2} sx={{ marginLeft: "auto" }}>
                  <Tooltip title="Εξαγωγή σε Excel">
                    <Button variant="contained" onClick={hideStatistics}>
                      Επιστροφή στον Πίνακα
                    </Button>
                  </Tooltip>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={3} hidden={hideFolder}>
              <FolderStructure
                panel={ngPanel}
                explorerDataKey={explorerDataKey}
                treeItems={treeItems}
              />
            </Grid>
            {allowed && (
              <Grid item xs={12} sm={12} md={2} hidden={hidePanel}>
                <PivotPanel id="sample-panel" itemsSource={ngPanel} />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={12}
              md={7 + (hideFolder ? 2 : 0) + (hidePanel || !allowed ? 2 : 0)}
              hidden={hideGrid}
            >
              <PivotGrid
                style={{ height: "100%", width: "98%" }}
                className="explorer-grid"
                initialized={(flex) => {
                  pivotGridRef.current = flex;

                  flex.hostElement.addEventListener("dblclick", (e) => {
                    let columnHeaders;
                    const ht = flex.hitTest(e.pageX, e.pageY);
                    try {
                      columnHeaders = flex.columnHeaders.columns[ht.col].binding
                        .split(";")
                        .slice(0, -2);
                    } catch (e) {
                      console.log(e);
                    }
                  });
                  const detailDialog = flex.detailDialog;
                  flex.detailDialog.isDraggable = true;
                  flex.detailDialog.dialogResultSubmit = "Ακύρωση";
                  detailDialog.showing.addHandler(function (s, e) {
                    const summary = s.hostElement.querySelector(".wj-summary");
                    const fmt = `${
                      s.rowHeader ? "Ανά: <b>{rowHeader}</b> " : ""
                    }${s.rowHeader && s.columnHeader ? "<br/>Και:" : ""}${
                      s.columnHeader ? "<b> {columnHeader}={cellValue}</b>" : ""
                    }`;
                    summary.innerHTML = format(fmt, s);
                    const header =
                      s.hostElement.querySelector(".wj-dialog-header");
                    header.innerHTML = format(
                      "Ευρετήριο: {detailCount} εγγραφές",
                      s
                    );
                    const buttonOk = s.hostElement.querySelector(".wj-hide");
                    buttonOk.innerHTML = "Ακύρωση";
                  });

                  const detailHost =
                    detailDialog.hostElement.querySelector(".wj-flexgrid");
                  const detailGrid = Control.getControl(detailHost);
                  Control.refreshAll(detailGrid);
                  detailGrid.loadedRows.removeAllHandlers();
                  detailDialog.hiding.removeAllHandlers();

                  detailGrid.hostElement.removeEventListener(
                    "dblclick",
                    (e) => handleDoubleClick(e, detailGrid),
                    true
                  );

                  detailGrid.selectionMode = "Row";
                  detailGrid.loadedRows.addHandler((s, e) => {
                    s.columns.forEach((c) => {
                      c.visible = false;
                      columns.forEach((gridColumn) => {
                        if (c.binding === gridColumn.binding) {
                          c.header = gridColumn.header;
                          c.visible = gridColumn.visible;
                          c.align = gridColumn.align;
                        }
                      });
                    });
                  }, false);

                  if (detailGrid.hostElement) {
                    detailGrid.hostElement.className += " explorer-grid";
                    detailGrid.hostElement.addEventListener("dblclick", (e) =>
                      handleDoubleClick(e, detailGrid)
                    );
                    detailGrid.hostElement.addEventListener("keydown", (e) => {
                      if (e.key === "Enter") {
                        if (detailGrid?.selectedItems[0]?.Id)
                          handleNavigate(detailGrid?.selectedItems[0], true);
                      }
                    });
                  }
                  detailDialog.hiding.addHandler((s, e) => {
                    detailGrid.hostElement.removeEventListener(
                      "dblclick",
                      (e) => handleDoubleClick(e, detailGrid)
                    );
                  }, false);
                }}
                loadedRows={(flex) => {
                  flex.columns.forEach((c, index) => {
                    if (index === flex.columns.length - 1) c.width = "*";
                  });
                  flex.autoSizeColumns(0, flex.columns.length - 2, false);
                }}
                itemsSource={ngPanel}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={
                hideGrid
                  ? 7 + (hideFolder ? 2 : 0) + (hidePanel || !allowed ? 2 : 0)
                  : 12
              }
              hidden={hideChart}
            >
              <PivotChart
                itemsSource={ngPanel}
                chartType="Pie"
                showTitle={false}
                show-legend="Auto"
              />
            </Grid>
          </>
        )}
      </Can>
    </>
  );
};

export default PivotComponents;
